'use client';

import React from 'react';
import { CatButton } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';

interface PartsCheckPriceProps {
  classNames?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  variant?: 'inline' | 'primary' | 'contrast' | 'danger' | 'ghost';
  onClick?: () => void;
  fullWidth?: boolean;
}
const PartsCheckPrice = ({
  classNames = 'mb-1',
  ...props
}: PartsCheckPriceProps) => {
  const t = useTranslations();
  const drawerControl = useDealerLocatorDrawer();

  return (
    <CatButton
      size="sm"
      variant="contrast"
      onClick={() => drawerControl.openDrawer()}
      className={classNames}
      {...props}
    >
      {t('CAT_CHECK_PRICE')}
    </CatButton>
  );
};

export default PartsCheckPrice;
